import axios from "axios";
import { API_URL } from "./../../utils/api-utils";
import  {common}  from "./../../utils";
export const ConnectDatabase = async (param)=>{
    let url = `${API_URL.Query}/api/Query/ConnectDB`;
    let { result } = await common.to(axios.post(url, param));
    if (result && result.data) return result.data; 
}
export const DisconnectDatabase = async (param)=>{
    let url = `${API_URL.Query}/api/Query/DisconnectDB`;
    let { result } = await common.to(axios.post(url, param));
    if (result && result.data) return result.data; 
}
export const GetConnectInfo = async (param)=>{
    let url = `${API_URL.Query}/api/Query/GetConnectDB`;
    let { result } = await common.to(axios.post(url, param));
    if (result && result.data) return result.data; 
}

export const GetListDB = async (param)=>{
    let url = `${API_URL.Query}/api/Query/GetListDB`;
    let { result } = await common.to(axios.post(url, param));
    if (result && result.data) return result.data; 
}

export const CountExecuteQuery = async (param)=>{
    let url = `${API_URL.Query}/api/Query/CountExecuteDB`;
    let { result } = await common.to(axios.post(url, param));
    if (result && result.data) return result.data.Result; 
}
export const GetListTable = async (param)=>{
    let url = `${API_URL.Query}/api/Query/GetListTableAndColumn`;
    let { result } = await common.to(axios.post(url, param));
    if (result && result.data) return result.data.Result; 
}
export const ExportCSV = async (param)=>{
    let url = `${API_URL.Query}/api/Query/ExportCSV`;
    let { result } = await common.to(axios.post(url, param));
    if (result && result.data) return result.data; 
}
export const ExportExcel = async (param)=>{
    let url = `${API_URL.Query}/api/Query/ExportExcel`;
    let { result } = await common.to(axios.post(url, param));
    if (result && result.data) return result.data; 
}
export const ExportAll = async (param)=>{
    let url = `${API_URL.Query}/api/Query/ExportAll`;
    let { result } = await common.to(axios.post(url, param));
    if (result && result.data) return result.data; 
}

var CancelToken = axios.CancelToken;
var cancel;
export const ExecuteQuery = async (param)=>{
    let url = `${API_URL.Query}/api/Query/ExecuteDB`;
    let { result } = await common.to(axios.post(url, param,
        { cancelToken: new CancelToken(function executor(c) {
            // An executor function receives a cancel function as a parameter
            cancel = c;
          })}
        ));
    if (result && result.data) return result.data.Result; 
}


export const cancelRequest = async ()=>{
    cancel("Cancel Request!");
}